import { cn, isMac } from "@/lib/utils";

function Kbd({ className, ...props }: React.ComponentProps<"kbd">) {
	return (
		<kbd
			data-slot="kbd"
			className={cn(
				"pointer-events-none inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-[4px] border bg-muted px-1 font-mono text-[10.5px] font-medium text-muted-foreground select-none",
				className,
			)}
			{...props}
		/>
	);
}

const KEY_LABELS: Record<string, string> = {
	mod: isMac ? "⌘" : "Ctrl",
	shift: "⇧",
	alt: isMac ? "⌥" : "Alt",
	enter: "↵",
	backspace: "⌫",
};

/** Renders a shortcut like `mod+k` (chord) or `g f` (sequence) as a row of keys. */
function Shortcut({ keys, className }: { keys: string; className?: string }) {
	const parts = keys.includes("+") ? keys.split("+") : keys.split(" ");
	return (
		<span className={cn("ml-auto inline-flex items-center gap-0.5", className)}>
			{parts.map((key, i) => (
				<Kbd key={`${key}-${i.toString()}`}>{KEY_LABELS[key] ?? key.toUpperCase()}</Kbd>
			))}
		</span>
	);
}

export { Kbd, Shortcut };
